var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.437 0L13.2785 1.45725H15.0459L14.2046 0H12.437Z",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.437 2.9147L13.2785 1.45725L12.437 0L11.5958 1.45725L12.437 2.9147Z",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2785 1.45703L12.437 2.91428H14.2046L15.0459 1.45703H13.2785Z",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25049 14.0889C8.50041 14.5218 8.75032 14.9548 9.00024 15.3877C9.52528 15.3877 10.0503 15.3877 10.5753 15.3877C10.3254 14.9548 10.0755 14.5218 9.82559 14.0891H8.25049",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25049 16.6864C8.5004 16.2534 8.75032 15.8205 9.00024 15.3877C8.75032 14.9548 8.5004 14.522 8.25049 14.0889C8.00057 14.5218 7.75065 14.9548 7.50073 15.3875C7.75065 15.8205 8.00057 16.2534 8.25049 16.6862",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00024 15.3877C8.75032 15.8206 8.50041 16.2536 8.25049 16.6864C8.77552 16.6864 9.30056 16.6864 9.82559 16.6864C10.0755 16.2534 10.3254 15.8206 10.5753 15.3877H9.00024Z",
    fillOpacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0144 14.4062L12.6728 15.5463H14.0554L13.3972 14.4062H12.0144Z",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0144 16.6864L12.6729 15.5463L12.0144 14.4062L11.3562 15.5463L12.0144 16.6864Z",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6728 15.5469L12.0144 16.6869H13.3972L14.0554 15.5469H12.6728Z",
    fillOpacity: 0.9
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9316 10.4951C14.2107 10.9785 14.4897 11.462 14.7688 11.9454C15.3553 11.9454 15.9415 11.9454 16.5277 11.9454C16.2486 11.462 15.9695 10.9785 15.6903 10.4951H13.9314",
    fillOpacity: 0.8
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9317 13.3956C14.2108 12.9121 14.4899 12.4287 14.769 11.9454C14.4899 11.462 14.2108 10.9785 13.9317 10.4951C13.6526 10.9785 13.3735 11.462 13.0944 11.9454C13.3735 12.4287 13.6526 12.9123 13.9317 13.3956Z",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7691 11.9443C14.49 12.4277 14.2109 12.911 13.9318 13.3946H15.6907C15.9698 12.9112 16.2489 12.4277 16.528 11.9443C15.9417 11.9443 15.3553 11.9443 14.7691 11.9443Z",
    fillOpacity: 0.9
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1428 3.29102C14.4524 3.82723 14.762 4.36363 15.0716 4.89985C15.7221 4.89985 16.3725 4.89985 17.0228 4.89985C16.7132 4.36363 16.4036 3.82723 16.094 3.29102C15.4435 3.29102 14.7933 3.29102 14.1428 3.29102Z",
    fillOpacity: 0.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.143 6.50868C14.4526 5.97247 14.7622 5.43606 15.0718 4.89985C14.7622 4.36344 14.4526 3.82723 14.143 3.29102C13.8334 3.82723 13.5238 4.36363 13.2142 4.89985C13.5238 5.43606 13.8334 5.97247 14.143 6.50868Z",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0717 4.90039C14.7621 5.43661 14.4525 5.97301 14.1429 6.50922C14.7934 6.50922 15.4439 6.50922 16.0942 6.50922C16.4038 5.97282 16.7134 5.43661 17.023 4.90039C16.3727 4.90039 15.7222 4.90039 15.0717 4.90039Z",
    fillOpacity: 0.9
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8487 6.58203L16.865 8.34244H19L17.9837 6.58203H15.8487Z",
    fillOpacity: 0.8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8486 10.1027L16.8649 8.34244L15.8486 6.58203L14.8322 8.34244L15.8486 10.1027Z",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.865 8.34277L15.8487 10.103H17.9837L19 8.34277H16.865Z",
    fillOpacity: 0.9
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5723 10.8105C2.82221 11.2435 3.07213 11.6763 3.32205 12.1092C3.84709 12.1092 4.37212 12.1092 4.89716 12.1092C4.64724 11.6764 4.39732 11.2435 4.1474 10.8105H2.5723Z",
    fillOpacity: 0.8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57232 13.4079C2.82224 12.9749 3.07216 12.5422 3.32208 12.1092C3.07216 11.6763 2.82224 11.2435 2.57232 10.8105C2.32241 11.2435 2.07249 11.6764 1.82257 12.1092C2.07249 12.5422 2.32241 12.9749 2.57251 13.4079",
    fillOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32212 12.1094C3.0722 12.5423 2.82228 12.9751 2.57217 13.408H4.14728C4.3972 12.9751 4.64712 12.5421 4.89703 12.1094C4.372 12.1094 3.84696 12.1094 3.32193 12.1094",
    fillOpacity: 0.9
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.658203 7.84961L1.31644 8.98968H2.69904L2.04099 7.84961H0.658203Z",
    fillOpacity: 0.8
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.658237 10.1298L1.31647 8.98968L0.658237 7.84961L0 8.98968L0.658237 10.1298Z",
    fillOpacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.31644 8.99023L0.658203 10.1303H2.04099L2.69904 8.99023H1.31644Z",
    fillOpacity: 0.9
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57529 3.93848C2.85438 4.42183 3.13348 4.90537 3.41258 5.38872C3.99881 5.38872 4.58524 5.38872 5.17148 5.38872C4.89238 4.90537 4.61328 4.42183 4.33418 3.93848C3.74795 3.93848 3.16152 3.93848 2.57529 3.93848Z",
    fillOpacity: 0.8
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57539 6.83896C2.85449 6.35561 3.13358 5.87207 3.41268 5.38872C3.13358 4.90537 2.85449 4.42183 2.57539 3.93848C2.29629 4.42183 2.0172 4.90518 1.7381 5.38872C2.0172 5.87207 2.29629 6.35561 2.57539 6.83896Z",
    fillOpacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41258 5.38867C3.13348 5.87202 2.85438 6.35537 2.57529 6.83891H4.33418C4.61328 6.35537 4.89238 5.87202 5.17148 5.38867H3.41258Z",
    fillOpacity: 0.9
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46482 0.0126953C8.77442 0.54891 9.08421 1.08531 9.39363 1.62153C10.0441 1.62153 10.6946 1.62153 11.3448 1.62153C11.0352 1.08513 10.7256 0.54891 10.416 0.0126953H8.46463",
    fillOpacity: 0.8
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46485 3.23036C8.77445 2.69415 9.08424 2.15774 9.39366 1.62153C9.08405 1.08513 8.77445 0.54891 8.46485 0.0126953C8.15525 0.54891 7.84564 1.08531 7.53604 1.62153C7.84564 2.15774 8.15544 2.69415 8.46485 3.23036Z",
    fillOpacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39363 1.62207C9.08402 2.15828 8.77442 2.6945 8.46463 3.2309C9.1151 3.2309 9.76557 3.2309 10.4158 3.2309C10.7254 2.69469 11.0351 2.15828 11.3447 1.62207C10.6944 1.62207 10.0439 1.62207 9.39344 1.62207",
    fillOpacity: 0.9
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49249 0.0263672L5.50884 1.78678H7.64384L6.6275 0.0263672H4.49249Z",
    fillOpacity: 0.8
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49246 3.54719L5.5088 1.78678L4.49246 0.0263672L3.47592 1.78678L4.49246 3.54719Z",
    fillOpacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50884 1.78613L4.49249 3.54655H6.6275L7.64384 1.78613H5.50884Z",
    fillOpacity: 0.9
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1936 3.15332C10.5457 3.76286 10.8975 4.37259 11.2496 4.98213C11.9889 4.98213 12.7282 4.98213 13.4678 4.98213C13.1159 4.3724 12.7639 3.76286 12.412 3.15332C11.6725 3.15332 10.9332 3.15332 10.1938 3.15332",
    fillOpacity: 0.8
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1936 6.81095C10.5457 6.20141 10.8975 5.59168 11.2496 4.98213C10.8977 4.3724 10.5457 3.76286 10.1936 3.15332C9.84156 3.76286 9.48971 4.37259 9.13766 4.98213C9.48971 5.59187 9.84156 6.20141 10.1936 6.81095Z",
    fillOpacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2496 4.98242C10.8977 5.59196 10.5457 6.20169 10.1936 6.81124C10.933 6.81124 11.6723 6.81124 12.4118 6.81124C12.7639 6.20151 13.1157 5.59196 13.4676 4.98242C12.7282 4.98242 11.9889 4.98242 11.2494 4.98242",
    fillOpacity: 0.9
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40817 6.91309C4.73028 7.4709 5.05239 8.02891 5.3745 8.58691C6.0513 8.58691 6.72792 8.58691 7.40453 8.58691C7.08242 8.02891 6.76032 7.47109 6.43821 6.91309C5.76159 6.91309 5.08479 6.91309 4.40817 6.91309Z",
    fillOpacity: 0.8
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40828 10.2607C4.73039 9.70273 5.05249 9.14491 5.3746 8.58691C5.05249 8.02891 4.73039 7.47109 4.40828 6.91309C4.08617 7.47109 3.76406 8.02891 3.44196 8.58691C3.76406 9.14491 4.08636 9.70273 4.40828 10.2607Z",
    fillOpacity: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37469 8.58691C5.05258 9.14492 4.73047 9.70273 4.40817 10.2607C5.08479 10.2607 5.76159 10.2607 6.43821 10.2607C6.76032 9.70273 7.08242 9.14473 7.40453 8.58691C6.72792 8.58691 6.05111 8.58691 5.3745 8.58691",
    fillOpacity: 0.9
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24409 3.01562C6.63838 3.69868 7.03268 4.38155 7.42698 5.06461C8.25536 5.06461 9.08375 5.06461 9.91195 5.06461C9.51765 4.38155 9.12335 3.69868 8.72905 3.01562H6.2439",
    fillOpacity: 0.8
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24411 7.11359C6.63841 6.43054 7.03271 5.74767 7.427 5.06461C7.03271 4.38155 6.63841 3.69868 6.24411 3.01562C5.84981 3.69868 5.45552 4.38155 5.06122 5.06461C5.45552 5.74767 5.84981 6.43053 6.2443 7.1134",
    fillOpacity: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42698 5.06445C7.03268 5.74751 6.63838 6.43038 6.2439 7.11344C7.07228 7.11344 7.90067 7.11344 8.72886 7.11344C9.12335 6.43038 9.51746 5.74732 9.91176 5.06445C9.08356 5.06445 8.25518 5.06445 7.42679 5.06445",
    fillOpacity: 0.9
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0863 10.1914C10.4084 10.7494 10.7305 11.3072 11.0527 11.8652C11.7295 11.8652 12.4061 11.8652 13.0827 11.8652C12.7606 11.3072 12.4385 10.7494 12.1164 10.1914H10.0863Z",
    fillOpacity: 0.8
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0865 13.5391C10.4086 12.981 10.7307 12.423 11.0528 11.8652C10.7307 11.3072 10.4086 10.7494 10.0863 10.1914C9.76421 10.7494 9.4421 11.3072 9.12 11.8652C9.4421 12.4232 9.76421 12.981 10.0865 13.5391Z",
    fillOpacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0528 11.8652C10.7307 12.4232 10.4086 12.9811 10.0863 13.5391C10.7631 13.5391 11.4398 13.5391 12.1164 13.5391C12.4385 12.9811 12.7606 12.4232 13.0827 11.8652C12.4061 11.8652 11.7293 11.8652 11.0527 11.8652",
    fillOpacity: 0.9
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9222 6.29395C12.3165 6.977 12.7108 7.65987 13.1053 8.34293C13.9335 8.34293 14.7619 8.34293 15.5903 8.34293C15.196 7.66006 14.8017 6.977 14.4074 6.29395C13.579 6.29395 12.7508 6.29395 11.9222 6.29395Z",
    fillOpacity: 0.8
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9223 10.3919C12.3166 9.70886 12.7109 9.02599 13.1054 8.34293C12.7111 7.65987 12.3168 6.977 11.9223 6.29395C11.528 6.97681 11.1337 7.65987 10.7394 8.34293C11.1337 9.02599 11.5282 9.70886 11.9225 10.3919",
    fillOpacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1053 8.34277C12.7108 9.02583 12.3167 9.7087 11.9222 10.3918H14.4072C14.8017 9.7087 15.1958 9.02564 15.5903 8.34277C14.7619 8.34277 13.9335 8.34277 13.1053 8.34277Z",
    fillOpacity: 0.9
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48627 13.7715L5.32773 15.2289L7.09515 15.2287L6.25369 13.7715H4.48627Z",
    fillOpacity: 0.8
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48617 16.6862L5.32763 15.2289L4.48617 13.7715L3.64471 15.2289L4.48617 16.6862Z",
    fillOpacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32773 15.2287L4.48627 16.686H6.25369L7.09515 15.2285L5.32773 15.2287Z",
    fillOpacity: 0.9
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24118 9.88867C6.6063 10.5211 6.97161 11.1536 7.33654 11.7861C8.10372 11.7861 8.87072 11.7861 9.63771 11.7861C9.27259 11.1536 8.90747 10.5211 8.54236 9.88867H6.24118Z",
    fillOpacity: 0.8
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24111 13.6835C6.60623 13.051 6.97135 12.4185 7.33647 11.7861C6.97135 11.1536 6.60623 10.5211 6.24111 9.88867C5.876 10.5211 5.51088 11.1536 5.14557 11.7861C5.51069 12.4185 5.876 13.051 6.24111 13.6835Z",
    fillOpacity: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33654 11.7861C6.97142 12.4186 6.6063 13.0511 6.24118 13.6835H8.54236C8.90747 13.0511 9.27259 12.4186 9.63771 11.7861C8.87072 11.7861 8.10372 11.7861 7.33654 11.7861Z",
    fillOpacity: 0.9
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99585 6.00488L9.34529 8.34225H12.1802L10.8308 6.00488H7.99585Z",
    fillOpacity: 0.8
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9959 10.6798L9.34534 8.34225L7.9959 6.00488L6.64627 8.34225L7.9959 10.6798Z",
    fillOpacity: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34529 8.34277L7.99585 10.6803H10.8308L12.1802 8.34277H9.34529Z",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.07afd939b7e6c90606acb364aaec15db.svg";
export { ForwardRef as ReactComponent };